import * as React from 'react'

import { AvailableButton } from "../../@components"
import { useAdminSkuForm } from "../../@hooks"


export default function AdminSkuFormAvailable({ availableType, label }) {
    const { localValue, handleChange } = useAdminSkuForm(availableType)

    return <AvailableButton
        label={label}
        status={localValue}
        onClick={() => handleChange(!localValue)}
    />
}